import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { X } from 'lucide-react';

function CookieConsent() {
 const [showBanner, setShowBanner] = useState(false);

 useEffect(() => {
 // Check if user has already accepted cookies
 const cookieConsent = localStorage.getItem('cookieConsent');
 if (!cookieConsent) {
 // Show banner after a short delay for better UX
 setTimeout(() => setShowBanner(true), 1000);
 }
 }, []);

 const acceptCookies = () => {
 localStorage.setItem('cookieConsent', 'accepted');
 setShowBanner(false);
 };

 const dismissBanner = () => {
 // User dismissed without accepting, still hide it for this session
 localStorage.setItem('cookieConsent', 'dismissed');
 setShowBanner(false);
 };

 if (!showBanner) return null;

 return (
 <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up">
 <div className="bg-gray-900 border-t-2 border-emerald-500 shadow-2xl">
 <div className="max-w-7xl mx-auto px-4 py-4 sm:px-6 lg:px-8">
 <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
 {/* Content */}
 <div className="flex-1">
 <div className="flex items-start gap-3">
 <div className="flex-shrink-0 mt-1">
 <span className="text-2xl"></span>
 </div>
 <div>
 <p className="text-sm text-gray-300 leading-relaxed">
 <strong className="text-white">We use cookies</strong> to enhance your experience, 
 keep you logged in, and remember your preferences. By using AnimeHouse, you agree to our{' '}
 <Link to="/privacy" className="text-emerald-400 hover:text-emerald-300 underline">
 Privacy Policy
 </Link>.
 </p>
 </div>
 </div>
 </div>

 {/* Buttons */}
 <div className="flex items-center gap-3 w-full sm:w-auto">
 <button
 onClick={acceptCookies}
 className="flex-1 sm:flex-none px-6 py-2 bg-emerald-500 hover:bg-emerald-600 text-white font-semibold rounded-lg transition-colors shadow-lg"
 >
 Accept
 </button>
 <button
 onClick={dismissBanner}
 className="flex-shrink-0 p-2 text-gray-400 hover:text-white transition-colors"
 aria-label="Close"
 >
 <X size={20} />
 </button>
 </div>
 </div>
 </div>
 </div>
 </div>
 );
}

export default CookieConsent;
